import { useContext } from "react";
import { PreviousPathContext } from "@/components/PreviousPath";

export function usePreviousPath() {
  return useContext(PreviousPathContext);
}
